/** Home tour notifications step: block header bell taps (Bootstrap dropdown + duplicate header bells). */

export const HOME_HEADER_NOTIFICATION_BELL_SELECTOR = '[data-tour="header-notification-bell"]';

const BELL_LOCK_CLASS = 'shepherd-home-notification-bell-locked';
const BELL_TOGGLE_STORE_ATTR = 'data-shepherd-stored-bs-toggle';

let bellInteractionBlocker: ((e: Event) => void) | null = null;

function isHomeNotificationBellTarget(target: EventTarget | null): boolean {
  return target instanceof Element && !!target.closest(HOME_HEADER_NOTIFICATION_BELL_SELECTOR);
}

export function lockHomeHeaderNotificationBells(): void {
  document.querySelectorAll(HOME_HEADER_NOTIFICATION_BELL_SELECTOR).forEach((node) => {
    if (!(node instanceof HTMLAnchorElement)) {
      return;
    }
    const toggle = node.getAttribute('data-bs-toggle');
    if (toggle) {
      node.setAttribute(BELL_TOGGLE_STORE_ATTR, toggle);
      node.removeAttribute('data-bs-toggle');
    }
    node.setAttribute('aria-disabled', 'true');
    node.setAttribute('tabindex', '-1');
    node.classList.add(BELL_LOCK_CLASS);
  });

  if (bellInteractionBlocker) {
    return;
  }
  bellInteractionBlocker = (e: Event) => {
    if (!isHomeNotificationBellTarget(e.target)) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  };
  document.addEventListener('click', bellInteractionBlocker, true);
  document.addEventListener('pointerdown', bellInteractionBlocker, true);
  document.addEventListener('mousedown', bellInteractionBlocker, true);
}

export function unlockHomeHeaderNotificationBells(): void {
  document.querySelectorAll(HOME_HEADER_NOTIFICATION_BELL_SELECTOR).forEach((node) => {
    if (!(node instanceof HTMLAnchorElement)) {
      return;
    }
    const storedToggle = node.getAttribute(BELL_TOGGLE_STORE_ATTR);
    if (storedToggle) {
      node.setAttribute('data-bs-toggle', storedToggle);
      node.removeAttribute(BELL_TOGGLE_STORE_ATTR);
    }
    node.removeAttribute('aria-disabled');
    node.removeAttribute('tabindex');
    node.classList.remove(BELL_LOCK_CLASS);
  });

  if (!bellInteractionBlocker) {
    return;
  }
  document.removeEventListener('click', bellInteractionBlocker, true);
  document.removeEventListener('pointerdown', bellInteractionBlocker, true);
  document.removeEventListener('mousedown', bellInteractionBlocker, true);
  bellInteractionBlocker = null;
}
